import styled from 'styled-components';

export const PageWrapper = styled.div`
  + div {
    width: 100%;
  }
`;

export const FormWrapper = styled.div`
  input {
    border: 1px solid ${({ theme }) => theme.themeColors.border};
    color: ${({ theme }) => theme.themeColors.text};
    background-color: transparent;
    border-radius: 6px;
    width: 100%;
    padding: 8px;
  }

  select {
    border: 1px solid ${({ theme }) => theme.themeColors.border};
    color: ${({ theme }) => theme.themeColors.text};
    background-color: transparent;
    border-radius: 6px;
    width: 100%;
    padding: 8px;
    -webkit-appearance: auto !important;
  }

  textarea {
    border: 1px solid ${({ theme }) => theme.themeColors.border};
    color: ${({ theme }) => theme.themeColors.text};
    background-color: transparent;
    border-radius: 6px;
    min-height: 300px;
    width: 100%;
    padding: 16px;
  }
`;

export const SubmitButtonWrapper = styled.div`
  text-align: center;
  width: 100%;
`;

export const ResultCard = styled.div`
  border: 1px solid ${({ theme }) => theme.themeColors.lowContrastBorder};
  border-radius: 6px;
  padding: 20px 24px;
  margin-bottom: 16px;
`;

export const MarkdownStyling = styled.span`
  td,
  th {
    padding: 8px;
    color: ${({ theme }) => theme.themeColors.text};
    border: 1px solid ${({ theme }) => theme.themeColors.lowContrastBorder};
    border-radius: 1px;
  }

  th {
    background: ${({ theme }) => theme.themeColors.lowContrastBorder};
    font-size: 12px;
    line-height: 14px;
    min-width: 120px;
  }

  ol,
  ul {
    padding-top: 8px;
    padding-bottom: 4px;
  }

  li {
    min-height: 28px;
    padding: 0 0 0 2px;
    margin-bottom: 12px;

    p {
      margin: 0;
    }
  }
`;
